/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetApplicationStatus200ResponseData } from './GetApplicationStatus200ResponseData'
import {
  GetApplicationStatus200ResponseDataFromJSON,
  GetApplicationStatus200ResponseDataFromJSONTyped,
  GetApplicationStatus200ResponseDataToJSON,
} from './GetApplicationStatus200ResponseData'

/**
 *
 * @export
 * @interface GetApplicationStatus200Response
 */
export interface GetApplicationStatus200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetApplicationStatus200Response
   */
  status: boolean
  /**
   *
   * @type {GetApplicationStatus200ResponseData}
   * @memberof GetApplicationStatus200Response
   */
  data: GetApplicationStatus200ResponseData
}

/**
 * Check if a given object implements the GetApplicationStatus200Response interface.
 */
export function instanceOfGetApplicationStatus200Response(
  value: object
): value is GetApplicationStatus200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetApplicationStatus200ResponseFromJSON(
  json: any
): GetApplicationStatus200Response {
  return GetApplicationStatus200ResponseFromJSONTyped(json, false)
}

export function GetApplicationStatus200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetApplicationStatus200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetApplicationStatus200ResponseDataFromJSON(json['data']),
  }
}

export function GetApplicationStatus200ResponseToJSON(
  value?: GetApplicationStatus200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetApplicationStatus200ResponseDataToJSON(value['data']),
  }
}
